<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2378_9241)">
      <path
        d="M3.64316 8.66667C1.56549 6.33333 5.10965 5.16667 6 4C6.89044 5.16667 10.4347 6.33333 8.35696 8.66667H3.64316Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8417 4.66658C10.469 2.99992 12.2448 2.16659 12.833 1.33325C13.4213 2.16659 15.197 2.99992 13.8243 4.66658H11.8417Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66634 2.43782C6.525 2.57916 6.32974 2.66659 6.11406 2.66659C5.6827 2.66659 5.33301 2.3169 5.33301 1.88554C5.33301 1.66986 5.42043 1.47459 5.56177 1.33325"
        :stroke="color"
        stroke-linecap="round"
      />
      <path
        d="M6 2.66675V3.33341V4.00008"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.333 11.3334V14.6667H2.76158C2.08814 14.6667 1.75143 14.6667 1.54222 14.4715C1.33301 14.2762 1.33301 13.962 1.33301 13.3334V11.3334C1.33301 10.0763 1.33301 9.4478 1.75143 9.05727C2.16985 8.66675 2.84328 8.66675 4.19015 8.66675H8.47587C9.82274 8.66675 10.4962 8.66675 10.9146 9.05727C11.333 9.4478 11.333 10.0763 11.333 11.3334Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 14.6667H11.7914C13.2252 14.6667 13.9421 14.6667 14.3555 14.2281C14.769 13.7894 14.6977 13.1045 14.555 11.7347L13.8189 4.66675H11.7358L11.0878 9.00008"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.66705 14.6667V13.3334C4.65552 11.3334 6.33366 10.6667 6.33366 10.6667C6.33366 10.6667 8.0118 11.3334 8.00027 13.3334V14.6667"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2378_9241">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
